var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInactiveStatusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75423 2.2459C6.96673 0.458398 4.0334 0.458398 2.2459 2.2459C0.458398 4.0334 0.458398 6.96673 2.2459 8.75423C4.0334 10.5417 6.9209 10.5417 8.7084 8.75423C10.4959 6.96673 10.5417 4.0334 8.75423 2.2459ZM6.7834 7.42507L5.50006 6.14173L4.21673 7.42507L3.57507 6.7834L4.8584 5.50006L3.57507 4.21673L4.21673 3.57507L5.50006 4.8584L6.7834 3.57507L7.42507 4.21673L6.14173 5.50006L7.42507 6.7834L6.7834 7.42507Z",
    fill: "#EF4444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveStatusIcon);
export default __webpack_public_path__ + "static/media/inactive_status_icon.66f12808c1d8e21ba6677f56f67fcf64.svg";
export { ForwardRef as ReactComponent };